module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad2/img_postcard-935c30603d848ad9ad4a5f65282d7a5f.jpg";